module.exports = __webpack_public_path__ + "img/hr-green-asterisk-09.c48606fa.png";